module.exports = __webpack_public_path__ + "en_GB-header-2e764e.webp";